import { Truthy } from "./isTruthy.types";

export default function<T>(value: T): value is Truthy<T> {
  return !!value;
}
